/**
 * Reusable SVG filter definitions for the painterly aesthetic.
 * Mounted once at the App root. See CLAUDE.md §6.5.
 *
 * Apply via Tailwind:  className="[filter:url(#painterly)]"
 * Or via style:        style={{ filter: 'url(#painterly)' }}
 *
 * PERFORMANCE: feDisplacementMap is GPU-expensive. Use on hero elements only
 * (~20 max on screen). For repeated elements, rely on the grain overlay
 * and warm shadows for texture instead.
 */
export function PainterlyFilters() {
  return (
    <svg
      aria-hidden="true"
      width="0"
      height="0"
      style={{ position: 'absolute', width: 0, height: 0 }}
    >
      <defs>
        {/* Soft watercolor edge distortion — for hero shapes */}
        <filter id="painterly">
          <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="2" seed="3" />
          <feDisplacementMap in="SourceGraphic" scale="6" />
        </filter>

        {/* Stronger torn-paper distortion — for wrapper edges and confetti scraps */}
        <filter id="painterly-rough">
          <feTurbulence type="fractalNoise" baseFrequency="0.08" numOctaves="3" seed="7" />
          <feDisplacementMap in="SourceGraphic" scale="12" />
        </filter>

        {/* Subtle warmth + glow — for the post-reveal voucher centre-stage */}
        <filter id="warm-bloom">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feColorMatrix
            in="blur"
            type="matrix"
            values="
              1.05 0    0    0 0
              0    1    0    0 0
              0    0    0.95 0 0
              0    0    0    1 0"
            result="warm"
          />
          <feMerge>
            <feMergeNode in="warm" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
}
